import type { StockFeedAlternatesFile } from "@/lib/generated/stockFeedAlternates";

let cache: StockFeedAlternatesFile | null = null;
let loading: Promise<StockFeedAlternatesFile> | null = null;

/** Lazy-load the ~100KB alternates map into its own chunk (not in the main Discovery bundle). */
export async function ensureStockFeedAlternates(): Promise<StockFeedAlternatesFile> {
  if (cache) return cache;
  loading ??= import("@/lib/generated/stockFeedAlternates").then((m) => {
    cache = m.STOCK_FEED_ALTERNATES;
    return cache;
  });
  return loading;
}

/** Public CDN URLs for Top-2 stock alternates (display-only feed dedupe). */
export function stockImageAlternatesForVenue(venueId: string): string[] {
  return cache?.venues[venueId] ?? [];
}

export function stockImageAlternatesForEvent(eventId: string): string[] {
  return cache?.events[eventId] ?? [];
}
